var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section',{staticClass:"full-text"},[_c('div',[_c('h1',[_vm._v(" "+_vm._s(_vm.page.longtitle)+" ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }